module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"nameTitle":"Jahr","initialYear":"Initial","addButton":"Jahr hinzufügen","editButton":"Bearbeiten","cancelButton":"Abbrechen","saveButton":"Speichern","yearAlreadyExistsError":"Jahr bereits vorhanden","yearInvalidError":"Jahr muss zwischen {minYear} und {maxYear} liegen","pendingLabel":"Wird gespeichert...","deleteConfirmation":"Wollen Sie dieses Jahr wirklich löschen?"}}')
  delete Component.options._Ctor
}
